export default {
  SET_REM_ROLE(state, remRole) {
    state.remRole = remRole;
  },
  SET_USER_PRMS_YN(state, userPrmsYn) {
    state.userPrmsYn = userPrmsYn;
  },
  SET_INFRA_MANAGER_YN(state, infraManagerYn) {
    state.infraManagerYn = infraManagerYn;
  },
  SET_RDS_MANAGER_YN(state, rdsManagerYn) {
    state.rdsManagerYn = rdsManagerYn;
  },
  SET_DIVISION_CD(state, divisionCd) {
    state.divisionCd = divisionCd;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/rem/user/remUserMutations.js